module.exports = __webpack_public_path__ + "static/media/Rey.2cfe40c8.png";